import { render, staticRenderFns } from "./AdminCommissionsScreen.vue?vue&type=template&id=45b4ad80&scoped=true&"
import script from "./AdminCommissionsScreen.vue?vue&type=script&lang=js&"
export * from "./AdminCommissionsScreen.vue?vue&type=script&lang=js&"
import style0 from "./AdminCommissionsScreen.vue?vue&type=style&index=0&id=45b4ad80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b4ad80",
  null
  
)

export default component.exports